import { InMemoryCache, InMemoryCacheConfig } from '@apollo/client/core';

export const createApolloCache = (options?: InMemoryCacheConfig) => new InMemoryCache(options);

export const cache = createApolloCache();
